import { render, staticRenderFns } from "./internalCommentBlock.vue?vue&type=template&id=5844d119&"
import script from "./internalCommentBlock.vue?vue&type=script&lang=js&"
export * from "./internalCommentBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports